import type { LangCode } from "@/lib/gql/__generated__/graphql";

import type { ProductPlanI18nFormModel } from "../type";

type Props = {
	hotelID: string;
	planID: string;
	lang: LangCode;
	queryData: ProductPlanI18nFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_PLAN_I18N_INPUT_MODEL = ({ hotelID, planID, lang, queryData }: Props) => {
	// 初期値に他の画面のでの設定値を使うため、queryData から必要な値を取得して代入する
	const { customEmailSetting } = queryData;
	const { reservation } = customEmailSetting;

	const inputModel: ProductPlanI18nFormModel["InputModel"] = {
		hotelID,
		planID,
		lang,

		name: "",

		emailTemplateReservation: reservation,

		mainTarget: null,

		questions: [],

		atCreated: {
			override: false,
			text: "",
		},
		atUpdated: {
			override: false,
			text: "",
		},
		atCanceled: {
			override: false,
			text: "",
		},
		atCheckInBefore_00days: {
			override: false,
			text: "",
			shouldSendEmail: false,
		},
		atCheckInBefore_01days: {
			override: false,
			text: "",
			shouldSendEmail: false,
		},
		atCheckInBefore_07days: {
			override: false,
			text: "",
			shouldSendEmail: false,
		},
		atCheckOutAfter_01days: {
			override: false,
			text: "",
			shouldSendEmail: false,
		},
	} satisfies ProductPlanI18nFormModel["InputModel"];

	return inputModel;
};
